/** Pure helpers for Cash Flow time period → API date range (testable without the page). */

export function isCashFlowCalendarYearPeriod(value: string): boolean {
  if (!/^\d{4}$/.test(value)) return false;
  const y = parseInt(value, 10);
  return y >= 1900 && y <= 2100;
}

function toISODateUTC(d: Date): string {
  return d.toISOString().split('T')[0];
}

export function cashFlowPeriodDisplayLabel(
  period: string,
  customStartDate: string,
  customEndDate: string
): string {
  if (period === 'last3months') return 'Last 3 Months';
  if (period === 'last6months') return 'Last 6 Months';
  if (period === 'last12months') return 'Last 12 Months';
  if (period === 'custom') return `${customStartDate} to ${customEndDate}`;
  if (isCashFlowCalendarYearPeriod(period)) return period;
  return 'Last 6 Months';
}

export type CashFlowDateRangeResult =
  | { ok: true; startDate: string; endDate: string }
  | { ok: false; error: string };

export function computeCashFlowDateRange(params: {
  selectedPeriod: string;
  customStartDate: string;
  customEndDate: string;
  now: Date;
}): CashFlowDateRangeResult {
  const { selectedPeriod, customStartDate, customEndDate, now } = params;
  let endDate = toISODateUTC(now);
  let startDate: string;

  if (selectedPeriod === 'custom') {
    if (
      customStartDate === '' ||
      customEndDate === '' ||
      customStartDate === undefined ||
      customEndDate === undefined
    ) {
      return { ok: false, error: 'Please select both start and end dates for custom range' };
    }
    return { ok: true, startDate: customStartDate, endDate: customEndDate };
  }

  switch (selectedPeriod) {
    case 'last3months':
      startDate = new Date(now.getTime() - 90 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];
      break;
    case 'last6months':
      startDate = new Date(now.getTime() - 180 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];
      break;
    case 'last12months':
      startDate = new Date(now.getTime() - 365 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];
      break;
    default:
      if (isCashFlowCalendarYearPeriod(selectedPeriod)) {
        const y = parseInt(selectedPeriod, 10);
        startDate = `${y}-01-01`;
        endDate = `${y}-12-31`;
      } else {
        startDate = new Date(now.getTime() - 180 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];
      }
  }

  return { ok: true, startDate, endDate };
}
